import React from 'react';
import styles from './FullTimeTag.module.scss';

export const FullTimeTag = () => <div className={styles.tag}>FTE</div>;
